export default __webpack_public_path__ + "static/media/insurenceicon.541da54a.svg";